module.exports = __webpack_public_path__ + "static/media/rounded-rect-danger.30b40f0b.png";